module.exports = __webpack_public_path__ + "static/media/Avatars_Other-17.3cbf380e.png";